export const useGeoData = () => {};
